import config from '../config';
import type { ServiceParams } from 'interface/service';

import http from 'utils/http';

export async function fetch(params: ServiceParams = {}) {
  const url = `${config.coreBaseURI}${config.endpoints.fiscalYears}?size=1000`;
  const { data } = await http.get(url, { params });

  return data;
}
